import React, { useState } from "react";

const Delete = (props) => {
  const [open, setOpen] = useState(false);

  const handleId = () => {
    props.setId(props.ItemId);
    setOpen(!open);
  };

  const handleClose = () => {
    props.setId(null);
    setOpen(!open);
  };

  const handleDelete = () => {
    props.onClick(props.id);
    setOpen(!open);
  };

  return (
    <>
      <button
        type="button"
        className="btn btn-danger btn-xs m-b-5 custom_btn"
        onClick={handleId}
      >
        <i className="fa fa-trash" aria-hidden="true"></i>
      </button>

      <div
        className={open ? "modal fade show" : "modal fade"}
        style={{ display: open ? "block" : "none" }}
      >
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <h1 className="modal-title fs-5" id="exampleModalLabel">
                Item Delete Confirmation
              </h1>
              <button
                type="button"
                className="btn-close"
                onClick={handleClose}
              ></button>
            </div>
            <div className="modal-body">Are You sure delete this item ?</div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-secondary"
                onClick={handleClose}
              >
                Close
              </button>
              <button
                type="button"
                className="btn btn-danger"
                onClick={handleDelete}
              >
                Yes, delete
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Delete;
